interface KeyValue {
  [index: string]: any[]
}
export default class EventBus {
  tasks: KeyValue = {}
  constructor() {
    this.tasks = {} // 按事件名称创建任务队列
  }
  /**
   * 注册事件（订阅）
   * @param {String} type  事件名称
   * @param {Function} fn  回调函数
   */
  on(type: string, fn: () => {}) {
    // 如果还没有注册过该事件，则创建对应事件的队列
    if (!this.tasks[type]) {
      this.tasks[type] = []
    }
    // 将回调函数加入队列
    this.tasks[type].push(fn)
  }

  /**
   * 注册一个只能执行一次的事件
   * @params type[String] 事件类型
   * @params fn[Function] 回调函数
   */
  once(type: string, fn: any) {
    if (!this.tasks[type]) {
      this.tasks[type] = []
    }

    const that = this
    // 注意该函数必须是具名函数，因为需要删除，但该名称只在函数内部有效
    function _once(...args: any) {
      fn(...args)
      that.off(type, _once) // 执行一次后注销
    }

    this.tasks[type].push(_once)
  }

  /**
   * 触发事件（发布）
   * @param {String} type  事件名称
   * @param {...any} args  传入的参数，不限个数
   */
  emit(type: string, ...args: any) {
    // 如果该事件没有被注册，则返回
    if (!this.tasks[type]) {
      return
    }
    // 遍历执行对应的回调数组，并传入参数
    this.tasks[type].forEach((fn) => fn(...args))
  }
  /**
   * 移除指定回调（取消订阅）
   * @param {String} type  事件名称
   * @param {Function} fn  回调函数
   */
  off(type: string, fn: any) {
    const tasks = this.tasks[type]

    // 校验事件队列是否存在
    if (!Array.isArray(tasks)) {
      return
    }

    // 利用 filter 删除队列中的指定函数
    this.tasks[type] = tasks.filter((cb) => fn !== cb)
  }
  clear() {
    this.tasks = {}
  }
}

// export default class EventBus {
//     _events:any=new Map()
//     constructor () {
//       this._events = new Map(); // 存储事件／回调键值对
//     }

//     // on 监听
//     on(type:any, fn:any) {
//       const handler = this._events.get(type); // 获取对应事件名称的函数清单
//       if (!handler) {
//           this._events.set(type, fn)
//       } else if (handler && typeof handler === 'function') {
//           // 如果handler是函数，说明当前只有一个监听者
//           // 再次添加监听者，需要改用 数组储存
//           this._events.set(type, [handler, fn]);
//       } else {
//           // 已有多个监听者，直接往数组里push函数即可
//           handler.push(fn);
//       }
//     }

//     // emit 触发
//     emit(type:any, ...args:any) {
//       const handler = this._events.get(type)

//       if (Array.isArray(handler)) {
//         // 是数组，说明有多个监听者，需要依次触发里边的函数
//         for (let i = 0; i < handler.length; ++i) {
//           if (args.length > 0) {
//             handler[i].apply(this, args)
//           } else {
//             handler[i].call(this);
//           }
//         }
//       } else {
//         // 单个函数的情况直接触发即可
//         if (args.length > 0) {
//           handler.apply(this, args)
//         } else {
//           handler.call(this)
//         }
//       }
//       return true
//     }

//     // off 移除监听
//     off(type:any, fn:any) {
//       const handler = this._events.get(type)
//       if (handler && typeof handler === 'function') {
//           // 函数，说明只有一个监听者，直接删除就行
//           this._events.delete(type)
//       } else {
//         handler.splice(handler.findIndex((e:any) => e === fn), 1)
//       }
//     }

//     // 单次执行
//     once(type:any, fn:any) {
//       const _self = this
//       function handler(...args:any) {
//         _self.off(type, handler)
//         fn(...args)
//       }
//       this.on(type, handler)
//     }
//   }
